import { render, staticRenderFns } from "./BlockGpay.vue?vue&type=template&id=b3d1ed4e&scoped=true&"
import script from "./BlockGpay.vue?vue&type=script&lang=js&"
export * from "./BlockGpay.vue?vue&type=script&lang=js&"
import style0 from "./BlockGpay.vue?vue&type=style&index=0&id=b3d1ed4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d1ed4e",
  null
  
)

export default component.exports